import { getStrategyColorByPath, findStrategyByLabel } from 'venn-ui-kit';

/**
 * Finds a strategy color by trying the full path and progressively shorter subpaths.
 * For single-item paths (when only one level is selected), searches the entire taxonomy tree.
 *
 * @example
 * // Tries ['a', 'b', 'c'], then ['b', 'c'], then ['c'], then searches by label 'a'
 * findRcmStrategyColor(['a', 'b', 'c'])
 */
export function findRcmStrategyColor(path: string[]): string | undefined {
  if (!path?.length) {
    return undefined;
  }

  // Try progressively shorter subpaths (e.g., [a,b,c] → [b,c] → [c])
  for (let i = 0; i < path.length; i++) {
    const subpath = path.slice(i);
    const color = getStrategyColorByPath(subpath);

    if (color) {
      return color;
    }
  }

  // Fallback: for single-item paths, search entire taxonomy by label
  if (path.length === 1) {
    return findStrategyByLabel(path[0]!)?.color;
  }

  return undefined;
}
